import React from "react";

interface SheetFooterProps {
  children: React.ReactNode;
  /** Custom className */
  className?: string;
}

/**
 * SheetFooter - Footer section of the sheet for action buttons
 */
export function SheetFooter({ children, className = "" }: SheetFooterProps) {
  return (
    <div
      className={`
        border-t border-solid border-primary
        flex flex-col gap-sm
        p-2xl
        ${className}
      `}
    >
      {children}
    </div>
  );
}
